import { Ptag } from "components/core";
import React from "react";

function Footer() {
  return (
    <div>
      <Ptag
        fontFamily="Merriweather"
        fontWeight="700"
        fontSize="24px"
        color="#4a4a4a"
        marginBottom="12px"
      >
        Securing Your Future, Today!
      </Ptag>
      <Ptag color="#4A4A4AAB" marginBottom="4px">
        CIN: U66220MH2023PTC415217
      </Ptag>
      <Ptag color="#4A4A4AAB">IRDAI Registration No. 932</Ptag>
    </div>
  );
}

export default Footer;
